import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseBase } from '../models/response-base';
import { Departamento } from '../models/departamento';
import { DepartamentoCadastro } from '../models/departamento-cadastro';

@Injectable({
  providedIn: 'root'
})
export class DepartamentoService {

  API: string = environment.API + 'Portal/departamentos';

  constructor(private http: HttpClient) { }

  add(departamento: DepartamentoCadastro, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Departamento>> {
    return this.http.post<ResponseBase<Departamento>>(`${this.API}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, departamento);
  }

  getAll(cedenteGuid: string): Observable<ResponseBase<Departamento[]>> {
    return this.http.get<ResponseBase<Departamento[]>>(`${this.API}/cedentes/${cedenteGuid}`);
  }

  delete(departamentoId: number, cedenteGuid: string, gestorGuid: string): Observable<ResponseBase<Departamento>> {
    return this.http.delete<ResponseBase<Departamento>>(`${this.API}/${departamentoId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`);
  }

  update(departamentoId: number, departamento: DepartamentoCadastro, cedenteGuid: string, gestorGuid: string):
  Observable<ResponseBase<Departamento>> {
    return this.http.put<ResponseBase<Departamento>>
    (`${this.API}/${departamentoId}/cedentes/${cedenteGuid}/gestores/${gestorGuid}`, departamento);
  }

  getById(departamentoId: number, cedenteGuid: string): Observable<ResponseBase<Departamento>> {
    return this.http.get<ResponseBase<Departamento>>(`${this.API}/${departamentoId}/cedentes/${cedenteGuid}`);
  }

}
